module.exports = __webpack_public_path__ + "static/media/TakeShot.a608ae9c.svg";